import { useEffect, useState } from "react";

import { useLocation, useNavigate } from "react-router-dom";

import { useQuery } from "@apollo/client";

import { Slider } from "@mui/material";

import { FaCheck } from "react-icons/fa";

import { useTranslation } from "react-i18next";

import WinterTyreTiers from "../../../Configs/WinterTyreTiers";

import { AVAILABILITY_TYPE_ENUM } from "../../../Queries/Products";

import { WinterTyrePriceBounds } from "../../../Queries/Tyres";

import { STUDS_ENUM } from "../../../Queries/Tyres";

import { WinterTyreStuds } from "../../../Queries/Tyres";

import SearchableSelect from "../../Shared/SearchableSelect";

const PAGINATION_KEYS = [ "f", "l", "a", "b", "p", "lp" ];

const readPrice = ( search, minimum, maximum ) => {

    const value = new URLSearchParams ( search ).get ( "pr" );

    if ( ! value ) return [ minimum, maximum ];

    const [ lower, upper ] = value.split ( "," ).map ( Number );

    return [

        Number.isFinite ( lower ) ? Math.max ( minimum, Math.min ( lower, maximum ) ) : minimum,

        Number.isFinite ( upper ) ? Math.min ( maximum, Math.max ( upper, minimum ) ) : maximum

    ];

};

const WinterCommercialFilters = ( { size, availableManufacturers = [] } ) => {

    const { search, pathname } = useLocation (),

    navigate = useNavigate (),

    { t } = useTranslation (),

    searchParams = new URLSearchParams ( search ),

    dimensionVariables = {

        ...( size ? {

            width: [ parseFloat ( size.width ) ],

            height: [ parseFloat ( size.height ) ],

            diameter: [ size.diameter ]

        } : {} ),

        ...(! size && searchParams.get ( "w" ) ? { width: [ parseFloat ( searchParams.get ( "w" ) ) ] } : {} ),

        ...(! size && searchParams.get ( "h" ) ? { height: [ parseFloat ( searchParams.get ( "h" ) ) ] } : {} ),

        ...(! size && searchParams.get ( "d" ) ? { diameter: [ searchParams.get ( "d" ) ] } : {})

    },

    priceBoundVariables = {

        ...dimensionVariables,

        ...(searchParams.get ( "m" ) ? { manufacturer: searchParams.get ( "m" ).split ( "," ) } : {}),

        ...(searchParams.get ( "av" ) ? { availability: searchParams.get ( "av" ).split ( "," ) } : {})

        ,

        ...(searchParams.get ( "st" ) ? { studs: [ searchParams.get ( "st" ) ] } : {})

        ,

        ...(WinterTyreTiers[ searchParams.get ( "tier" ) ] ? { manufacturer: WinterTyreTiers[ searchParams.get ( "tier" ) ] } : {})

    },

    { loading: priceBoundsLoading, data: priceBoundsData } = useQuery ( WinterTyrePriceBounds, {

        variables: priceBoundVariables

    } ),

    { loading, data } = useQuery ( AVAILABILITY_TYPE_ENUM );

    const { loading: studsLoading, data: studsData } = useQuery ( STUDS_ENUM );

    const { loading: availableStudsLoading, data: availableStudsData } = useQuery ( WinterTyreStuds, {

        variables: {

            ...dimensionVariables,

            ...(searchParams.get ( "m" ) ? { manufacturer: searchParams.get ( "m" ).split ( "," ) } : {})

        }

    } );

    const availableStuds = new Set ( ( availableStudsData?.winterTyreStuds || [] ).map ( option => option.value ) );

    const minimum = Number ( priceBoundsData?.winterTyrePriceBounds?.min ),

    maximum = Number ( priceBoundsData?.winterTyrePriceBounds?.max ),

    hasBounds = Number.isFinite ( minimum ) && Number.isFinite ( maximum ) && maximum > minimum,

    sliderMinimum = hasBounds ? minimum : 0,

    sliderMaximum = hasBounds ? maximum : 10;

    const availableManufacturerValues = availableManufacturers

        .map ( manufacturer => manufacturer.value || manufacturer )

        .map ( value => value.toLowerCase () ),

    availableTiers = Object.keys ( WinterTyreTiers ).filter ( tier => WinterTyreTiers[ tier ].some ( manufacturer => availableManufacturerValues.includes ( manufacturer ) ) );

    const [ price, setPrice ] = useState ( readPrice ( search, sliderMinimum, sliderMaximum ) );

    useEffect ( () => {

        setPrice ( readPrice ( search, sliderMinimum, sliderMaximum ) );

    }, [ search, sliderMinimum, sliderMaximum ] );

    const navigateWithFilters = updates => {

        const next = new URLSearchParams ( search );

        PAGINATION_KEYS.forEach ( key => next.delete ( key ) );

        Object.entries ( updates ).forEach ( ( [ key, value ] ) => {

            if ( value === null || value === undefined || value === "" ) next.delete ( key );

            else next.set ( key, value );

        } );

        navigate ( {

            pathname,

            search: next.toString () ? `?${ next.toString () }` : ""

        } );

    };

    const applyPrice = value => {

        const [ lower, upper ] = value;

        setPrice ( value );

        navigateWithFilters ( {

            pr: lower === sliderMinimum && upper === sliderMaximum ? null : `${ lower },${ upper }`

        } );

    };

    const toggleAvailability = value => {

        const current = new URLSearchParams ( search ).get ( "av" )?.split ( "," ).filter ( Boolean ) || [];

        const next = current.includes ( value ) ? current.filter ( item => item !== value ) : [ ...current, value ];

        navigateWithFilters ( { av: next.length ? next.join ( "," ) : null } );

    };

    const selectedAvailability = new URLSearchParams ( search ).get ( "av" )?.split ( "," ).filter ( Boolean ) || [];

    return ( <section className="winter-tyres-page__commercial-filters" aria-labelledby="winter-commercial-filters-title">

        <h2 id="winter-commercial-filters-title">{ t ( "filters" ) }</h2>

        <div className="winter-tyres-page__commercial-grid">

            <div className="winter-tyres-page__price-filter">

                <h3>{ t ( "price_range" ) }</h3>

                <Slider

                    value={ price }

                    onChange={ ( event, value ) => setPrice ( value ) }

                    onChangeCommitted={ ( event, value ) => applyPrice ( value ) }

                    min={ sliderMinimum }

                    max={ sliderMaximum }

                    step={ 10 }

                    disabled={ priceBoundsLoading || ! hasBounds }

                    valueLabelDisplay="auto" />

                <div className="winter-tyres-page__price-output">

                    <span>&euro; { price[ 0 ] }</span>

                    <span>&euro; { price[ 1 ] }</span>

                </div>

            </div>

            <div className="winter-tyres-page__availability-filter">

                <h3>{ t ( "availability" ) }</h3>

                { loading ? <p>{ t ( "loading" ) }</p> : data?.__type?.enumValues?.map ( option => <label className="winter-tyres-page__checkbox" key={ option.name }>

                    <input

                        type="checkbox"

                        checked={ selectedAvailability.includes ( option.name ) }

                        onChange={ () => toggleAvailability ( option.name ) } />

                    <span className="winter-tyres-page__checkbox-mark"><FaCheck /></span>

                    <span>{ t ( `av_${ option.name }` ) }</span>

                </label> ) }

            </div>

            <div className="winter-tyres-page__studs-filter">

                <h3>{ t ( "studs" ) }</h3>

                { studsLoading || availableStudsLoading ? <p>{ t ( "loading" ) }</p> : <SearchableSelect

                    options={ studsData?.__type?.enumValues?.filter ( option => availableStuds.has ( option.name ) ).map ( option => ( {

                        text: option.name === "yes" ? t ( "studs_yes" ) : t ( `studs_${ option.name }` ),

                        value: option.name

                    } ) ) || [] }

                    value={ searchParams.get ( "st" ) || "default" }

                    onChange={ value => navigateWithFilters ( { st: value === "default" ? null : value } ) }

                    label={ t ( "select_option" ) }

                /> }

            </div>

            <div className="winter-tyres-page__tier-filter">

                <h3>{ t ( "quality" ) }</h3>

                <SearchableSelect

                    options={ [

                        { text: t ( "quality_premium" ), value: "premium" },

                        { text: t ( "quality_mid" ), value: "quality" },

                        { text: t ( "quality_budget" ), value: "budget" }

                    ].filter ( option => availableTiers.includes ( option.value ) ) }

                    value={ searchParams.get ( "tier" ) || "default" }

                    onChange={ value => navigateWithFilters ( value === "default" ? { tier: null } : { tier: value, m: null } ) }

                    label={ t ( "select_option" ) }

                />

            </div>

        </div>

    </section> );

};

export default WinterCommercialFilters;